module.exports = __webpack_public_path__ + "img/empty.d72c563a.png";